// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class NotificationTypeChannelNestedResource extends Resource {
    basePath: string = 'notifications/notification-types-channels/{parent}/channel/';

    objectPath: string = 'notifications/notification-types-channels/{parent}/channel/{ident}/';
}
